import { render } from "./WebDevelopment.vue?vue&type=template&id=61b4e385&scoped=true"
import script from "./WebDevelopment.vue?vue&type=script&lang=js"
export * from "./WebDevelopment.vue?vue&type=script&lang=js"

import "./WebDevelopment.vue?vue&type=style&index=0&id=61b4e385&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b4e385"]])

export default __exports__